import React, { useState } from 'react';
import { PARTNER_LOGOS } from '../data/catalog';
import './TrustBar.css';

function PartnerLogo({ name, logo }) {
  const [failed, setFailed] = useState(false);
  return (
    <span className="trustbar__logo" title={name}>
      {failed ? (
        <span className="trustbar__wordmark">{name}</span>
      ) : (
        <img
          src={logo}
          alt={name}
          loading="lazy"
          onError={() => setFailed(true)}
        />
      )}
    </span>
  );
}

export default function TrustBar() {
  const list = [...PARTNER_LOGOS, ...PARTNER_LOGOS];
  return (
    <section className="trustbar" aria-label="MyCard 可儲值遊戲發行商">
      <div className="container">
        <div className="trustbar__head">
          <span className="trustbar__label">
            MyCard 支援 300+ 款遊戲 · 涵蓋全球頂尖發行商
          </span>
        </div>
        <div className="trustbar__track-wrap">
          <div className="trustbar__track">
            {list.map((p, i) => (
              <PartnerLogo key={i} name={p.name} logo={p.logo} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
